import { Select, MenuItem, styled } from "@mui/material";

export const StyledSelectField = styled(Select)(({ theme }) => ({
  paddingTop: 0,
  minHeight: 44,
  height: 'inherit',
  "&.MuiInput-root": {
    marginTop: 0,
  },
  "& .MuiSelect-select": {
    paddingTop: "10px",
    "&.MuiSelect-outlined": {
      minHeight: "1.26em",
      textAlign: "left",
      borderWidth: "4px",
    },
    "&.MuiSelect-standard": {
      minWidth: "40px",
      paddingTop: 0,
      // textAlign: "left",
    },
  },
  "& .MuiInputBase-input ": {
    ...theme.typography.h6,
    padding: "8.1px 14px 8.1px 12px",
  },
}));

export const StyledSelectItem = styled(MenuItem)(({ theme }) => {
  return {
    // "&:hover": {
    //   background: "#8c8c8c59",
    // },
    "&.Mui-selected,&:hover,&.Mui-selected:hover": {
      // "&:hover": {
      //   background: "#8c8c8c59",
      // },
      background: "#8c8c8c33",
    },
  };
});
